window.addEventListener("load", function (event) {
	let ACCORDIONS = document.querySelectorAll("[data-simple-accordion]");
	[...ACCORDIONS].forEach(function (_DIV) {
		if (_DIV.getAttribute("data-simple-accordion") != "false") {
			buildSimpleAccordions(_DIV, _DIV.getAttribute("data-simple-accordion"));
		}
	});
});

function buildSimpleAccordions(_DIV, _PROPS) {
	let BTN = _DIV.querySelector("button");
	BTN.classList.add("w-full", "flex", "flex-row", "justify-between");
	let INDICATOR = document.createElement("span");
	INDICATOR.innerHTML = `+`;
	INDICATOR.className = "transform duration-300 text-black";
	BTN.append(INDICATOR);

	let PANEL = _DIV.querySelector("div");
	PANEL.classList.add("overflow-hidden", "max-h-0", "h-auto", "duration-300");

	if (_PROPS == "active") {
		// console.log("is_OPEN active");
		PANEL.style.maxHeight = PANEL.scrollHeight + "px";
		INDICATOR.classList.add("rotate-45");
	} else {
		// console.log("is_CLOSED ");
		PANEL.style.maxHeight = null;
		INDICATOR.classList.remove("rotate-45");
	}

	BTN.addEventListener("click", function (e) {
		if (PANEL.style.maxHeight) {
			PANEL.style.maxHeight = null;
			INDICATOR.classList.remove("rotate-45");
		} else {
			PANEL.style.maxHeight = PANEL.scrollHeight + "px";
			INDICATOR.classList.add("rotate-45");
		}
	});
}

export {};
